import loadable from '@loadable/component'

export default [
  {
    path: '/game/LuckySlot',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-game-LuckySlot" */ '~/pages/game/LuckySlot'
        )
    ),
  },
  {
    path: '/gameRoom/LuckySlot',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-gameRoom-luckySlot" */ '~/pages/game/gameRoom/LuckySlot'
        )
    ),
  },
  {
    path: '/gameRoom/LuckySlot/rule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-game-luckySlot-rules" */ '~/pages/game/gameRoom/LuckySlot/Rules'
        )
    ),
  },
  {
    path: '/gameRoom/LuckySlot/record',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-game-luckySlot-record" */ '~/pages/game/gameRoom/LuckySlot/Record'
        )
    ),
  },
]
